import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import DetailWriteDTO from '../../../../../../types/detail/DetailWriteDTO';
import { DetailService } from '../../../../services/detail.service';

@Component({
    selector: 'app-update-detail-dialog',
    templateUrl: './update-detail-dialog.component.html',
    styleUrls: [ './update-detail-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        CheckboxModule,
        IconField,
        InputIcon,
        IftaLabelModule
    ]
})
export class UpdateDetailDialogComponent implements OnInit, OnChanges {
    @Input() visible: boolean = false;
    @Input() detail: DetailWriteDTO = new DetailWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() detailUpdated: EventEmitter<DetailWriteDTO> = new EventEmitter<DetailWriteDTO>();

    public loading = false;

    constructor(
        private detailService: DetailService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        // Initialization logic if needed
    }

    ngOnChanges(changes: SimpleChanges): void {
        // If needed, respond to changes to the input detail
    }

    get saveDisabled(): boolean {
        return !this.detail?.name;
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateDetail(): void {
        this.loading = true;
        this.detailService
            .updateDetail(this.detail)
            .then(() => {
                this.detailUpdated.emit(this.detail);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
